import { render, staticRenderFns } from "./DecorationMethods.vue?vue&type=template&id=4b1f68e0&scoped=true"
import script from "./DecorationMethods.vue?vue&type=script&lang=js"
export * from "./DecorationMethods.vue?vue&type=script&lang=js"
import style0 from "./DecorationMethods.vue?vue&type=style&index=0&id=4b1f68e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f68e0",
  null
  
)

export default component.exports